import { render, staticRenderFns } from "./ReferenceTypeEditor.vue?vue&type=template&id=421a4b40"
import script from "./ReferenceTypeEditor.vue?vue&type=script&lang=ts"
export * from "./ReferenceTypeEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports